import { ProductionAssumptionsData } from '../types/widget';

/**
 * Mock Data for the Production Assumptions Widget
 *
 * This data is based on the real "PROTOTYPE" data
 * discovered through our SQL queries:
 * - Original Budget: $4,540,290.00
 * - Original Schedule: 12 Days
 * - Original Pages: 50.125
 * - Current Budget (calc): $4,406,046.00 (Original + -134,244 variance)
 * - Current Schedule: 13 Days
 * - Current Pages (calc): 54.875 (Sum of all 13 DPRs)
 */
export const mockAssumptionsData: ProductionAssumptionsData = {
  productionTitle: 'PROTOTYPE',
  baselineVersion: 'Original (v1)',
  metrics: {
    schedule: {
      name: 'Schedule (Days)',
      original: 12,
      current: 13,
      variance: 1, // 13 - 12
    },
    budget: {
      name: 'Budget (USD)',
      original: 4540290.0,
      current: 4406046.0,
      variance: -134244.0, // (4406046.00 - 4540290.00)
    },
    creative: {
      name: 'Creative (Pages)',
      original: 50.125,
      current: 54.875, // Note: This is a mock sum of all 13 DPRs
      variance: 4.75, // 54.875 - 50.125
    },
  },
};

